import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["mainImage", "thumbnail", "expandButton", "expandableContent", "faqQuestion", "faqAnswer"]

    connect() {
        this.initializeGallery()
        this.initializeCollapsibleSections()
        this.initializeFAQSections()
        this.initializeScrollToGroups()
    }

    initializeGallery() {
        if (!this.hasMainImageTarget) {
            return
        }
        
        this.thumbnailTargets.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', (e) => {
                e.preventDefault()
                this.switchMainImage(thumbnail)
            })
        })

        this.syncActiveThumbnailWithMain()
    }

    syncActiveThumbnailWithMain() {
        if (!this.hasMainImageTarget) {
            return
        }
        const mainSrc = this.mainImageTarget?.src
        let matched = false
        this.thumbnailTargets.forEach((thumb) => {
            const candidate = thumb.dataset.main || thumb.src
            if (!matched && candidate === mainSrc) {
                thumb.classList.add('active')
                matched = true
            } else {
                thumb.classList.remove('active')
            }
        })
        if (!matched && this.thumbnailTargets[0]) {
            this.thumbnailTargets.forEach(t => t.classList.remove('active'))
            this.thumbnailTargets[0].classList.add('active')
        }
    }

    async switchMainImage(clickedThumbnail) {
        const newMainImageSrc = clickedThumbnail.dataset.main || clickedThumbnail.src
        const mainImage = this.mainImageTarget
        const currentMainImageSrc = mainImage.src
        
        if (!newMainImageSrc) {
            return
        }
        
        if (newMainImageSrc === currentMainImageSrc) {
            return
        }
        mainImage.style.opacity = '0.2'
        try {
            await this.preloadImage(newMainImageSrc)
            mainImage.src = newMainImageSrc
        } catch (e) {
            mainImage.src = newMainImageSrc
        }
       
        this.thumbnailTargets.forEach(thumb => thumb.classList.remove('active'))
        clickedThumbnail.classList.add('active')
        setTimeout(() => { mainImage.style.opacity = '1' }, 50)
    }

    preloadImage(src) {
        return new Promise((resolve, reject) => {
            const img = new Image()
            img.onload = () => resolve(true)
            img.onerror = reject
            img.src = src
        })
    }

    initializeCollapsibleSections() {
        this.expandButtonTargets.forEach((button, index) => {
            button.addEventListener('click', (e) => {
                e.preventDefault()
                this.toggleExpandableSection(button)
            })
        })
    }

    toggleExpandableSection(button) {
        const targetId = button.dataset.target
        const content = document.getElementById(targetId)
        const icon = button.querySelector('.expand-icon')
        const textSpan = button.querySelector('span:first-child')
        
        if (!content) {
            return
        }

        const isCurrentlyHidden = content.style.display === 'none' || 
                                  getComputedStyle(content).display === 'none' ||
                                  content.style.display === ''
        
        if (isCurrentlyHidden) {
            content.style.display = 'block'
            requestAnimationFrame(() => {
                content.classList.add('show')
            })
            button.classList.add('expanded')
            if (textSpan) textSpan.textContent = 'Suskleisti'
        } else {
            content.classList.remove('show')
            setTimeout(() => {
                content.style.display = 'none'
                button.classList.remove('expanded')
                if (textSpan) textSpan.textContent = 'Skaityti daugiau'
            }, 200)
        }
    }

    initializeFAQSections() {
        this.element.addEventListener('click', (e) => {
            const faqButton = e.target.closest('.faq-question')
            if (faqButton) {
                e.preventDefault()
                this.toggleFAQAnswer(faqButton)
            }
        })
    }

    toggleFAQAnswer(question) {
        const targetId = question.dataset.target
        const answer = document.getElementById(targetId)
        const icon = question.querySelector('.faq-icon')
        
        if (!answer) {
            return
        }

        const isCurrentlyHidden = answer.style.display === 'none' || 
                                  getComputedStyle(answer).display === 'none' ||
                                  answer.style.display === ''
        
        if (isCurrentlyHidden) {
            answer.style.display = 'block'
            requestAnimationFrame(() => {
                answer.classList.add('show')
            })
            question.classList.add('expanded')
        } else {
            answer.classList.remove('show')
            setTimeout(() => {
                answer.style.display = 'none'
            }, 200)
            question.classList.remove('expanded')
        }
    }

    initializeScrollToGroups() {
        const selectGroupsButton = document.querySelector('.select-groups-button')
        
        if (selectGroupsButton) {
            selectGroupsButton.addEventListener('click', (e) => {
                e.preventDefault()
                this.scrollToFiltersAndGroups()
            })
        }
    }

    scrollToFiltersAndGroups() {
        const filterSection = this.element.querySelector('.product-filter')
        
        if (filterSection) {
            const headerOffset = 120
            const elementPosition = filterSection.getBoundingClientRect().top
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            })
        }
    }

    disconnect() {
        
    }
}